/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */

/* ==========================================================================================================
 * TB4A — Gallery ⇄ Variant sync  (v2, Oct 2026, written for Warehouse 7.0.1)
 * ----------------------------------------------------------------------------------------------------------
 * PROBLEM  : Customers browse product images (thumbnail click or mobile swipe), then hit "Add to cart" — but
 *            the Color/Scent dropdown never changed, so the wrong variant is added (returns/refunds).
 *
 * HOW      : Every product image's ALT text is set to the exact option value it shows ("White", "Navy Blue",
 *            "8oz Ocean Breeze"). Whenever the gallery's active image changes, we find the option control
 *            (dropdown <option>, or swatch/block radio) whose label matches that alt text, select it, and
 *            fire a native `change` event. Warehouse's own <variant-picker> component then does everything
 *            else the proper way: re-renders price / hidden variant id / URL / buy button / gallery filter.
 *
 * WHY THIS WAY (vs the 2020 jQuery script):
 *   - Zero Liquid edits → lives only in custom.js, which Shopify preserves on theme updates.
 *   - No jQuery (saves ~89 KB on every page).
 *   - Handles thumbnail clicks AND swipes / arrows / keyboard (anything that changes the active slide).
 *   - Never writes the hidden variant id itself — the theme owns that, so it can't drift out of sync.
 *   - Images whose alt doesn't match any option ("Top View", "Size Chart") are simply ignored.
 *
 * ALT TEXT RULES (content team):
 *   - Alt = the option value, spelled exactly as in the variant (case/extra spaces are tolerated).
 *   - Optional Warehouse convention also supported: "Any description # Color_Navy Blue".
 * ========================================================================================================== */
(function () {
  'use strict';

  var DEBUG = /tb4a_debug=1/.test(window.location.search);
  function log() { if (DEBUG && window.console) console.log.apply(console, ['[TB4A sync]'].concat([].slice.call(arguments))); }

  function norm(s) { return (s || '').replace(/\s+/g, ' ').trim().toLowerCase(); }

  /** The option value name a media cell represents ("Navy Blue"), or '' if none. */
  function mediaValueName(cell) {
    var groupValue = cell.getAttribute('data-group-value'); // Warehouse "# Color_Value" alt convention
    if (groupValue) return groupValue;
    var img = cell.querySelector('img');
    var alt = img ? (img.getAttribute('alt') || '') : '';
    if (alt.indexOf('#') !== -1) {                           // "desc # Color_Value" fallback parse
      var tail = alt.split('#').pop().split('_');
      return tail.length > 1 ? tail.slice(1).join('_') : '';
    }
    return alt;
  }

  /** Label text for a radio option (swatch / block / variant-image swatch). */
  function radioLabelText(input) {
    if (!input.id) return '';
    var label = document.querySelector('label[for="' + input.id.replace(/"/g, '\\"') + '"]');
    if (!label) return '';
    return label.getAttribute('title') || label.textContent || '';
  }

  /**
   * Select the option whose name matches `name` inside `form`.
   * Returns true if a matching option exists (whether or not it needed changing).
   */
  function selectOptionByName(form, name) {
    var target = norm(name);
    if (!target) return false;

    var controls = [].filter.call(form.elements, function (el) {
      return el.hasAttribute('data-option-position') && (el.tagName === 'SELECT' || el.type === 'radio');
    });

    for (var i = 0; i < controls.length; i++) {
      var el = controls[i];

      if (el.tagName === 'SELECT') {
        for (var j = 0; j < el.options.length; j++) {
          var opt = el.options[j];
          if (norm(opt.textContent) === target) {
            if (el.value !== opt.value) {
              el.value = opt.value;
              el.dispatchEvent(new Event('change', { bubbles: true }));
              log('dropdown →', opt.textContent.trim());
            }
            return true;
          }
        }
      } else if (norm(radioLabelText(el)) === target) {
        if (!el.checked) {
          el.checked = true;
          el.dispatchEvent(new Event('change', { bubbles: true }));
          log('swatch →', radioLabelText(el).trim());
        }
        return true;
      }
    }
    return false;
  }

  function initGallery(carousel) {
    if (carousel.__tb4aSync) return;

    var container = carousel.closest('product-rerender') || carousel.closest('.shopify-section') || document;
    var picker = container.querySelector('variant-picker[form-id]');
    if (!picker) return; // single-variant product, or gallery outside a product form

    var formId = picker.getAttribute('form-id');
    var form = document.forms[formId];
    if (!form) return;

    carousel.__tb4aSync = true;
    var suppressUntil = 0;         // ignore gallery moves the THEME itself makes right after a variant change
    var lastMediaId = null;

    function activeCell() {
      return carousel.querySelector('.product-gallery__carousel-item.is-selected');
    }

    function onActiveMediaChanged() {
      var cell = activeCell();
      if (!cell) return;
      var mediaId = cell.getAttribute('data-media-id');
      if (mediaId === lastMediaId) return;
      lastMediaId = mediaId;

      if (Date.now() < suppressUntil) { log('skip (theme-driven move)'); return; }

      var name = mediaValueName(cell);
      log('active image', mediaId, 'alt =', JSON.stringify(name));
      if (!name) return;
      selectOptionByName(document.forms[formId] || form, name);
    }

    // Flickity toggles `is-selected` on the active slide for clicks, swipes, arrows and keyboard alike.
    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].target.classList.contains('is-selected')) { onActiveMediaChanged(); break; }
      }
    });
    observer.observe(carousel, { attributes: true, attributeFilter: ['class'], subtree: true });

    // When the variant changes via the dropdown, the theme moves the gallery to that variant's featured
    // image itself. Briefly ignore that move so we never fight the theme (and never loop).
    form.addEventListener('variant:changed', function () { suppressUntil = Date.now() + 400; });

    var first = activeCell();
    lastMediaId = first ? first.getAttribute('data-media-id') : null;
    log('initialised on', formId);
  }

  function initAll() {
    document.querySelectorAll('.product-gallery__carousel').forEach(initGallery);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();

  // Galleries that appear later: quick-view / quick-buy modals, theme-editor section reloads, full re-renders.
  document.addEventListener('shopify:section:load', initAll);
  var scheduled = false;
  new MutationObserver(function () {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () { scheduled = false; initAll(); });
  }).observe(document.body, { childList: true, subtree: true });
})();
